var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgCw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-cw",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cw-a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M0 0h682.7v512H0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "cw-b",
    d: "m0-1 .2.7H1L.3 0l.2.7L0 .4l-.6.4.2-.7-.5-.4h.7z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cw-a)",
    transform: "scale(.94)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#002b7f",
    d: "M0 0h768v512H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9e814",
    d: "M0 320h768v64H0z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cw-b",
    width: 13500,
    height: 9000,
    x: 2,
    y: 2,
    fill: "#fff",
    transform: "scale(42.67)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cw-b",
    width: 13500,
    height: 9000,
    x: 3,
    y: 3,
    fill: "#fff",
    transform: "scale(56.9)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCw);
export default __webpack_public_path__ + "static/media/cw.7b83329130ff6a4d69d47c376dbebc79.svg";
export { ForwardRef as ReactComponent };